import React, { useState } from 'react'

import { BottomSheetScrollView } from '@gorhom/bottom-sheet'
import { publishEvent } from '@zet/analytics'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { B4, BottomSheet, colors, H5, Stack, XStack } from '@zet/design-system'
import { Accordian } from '@zet/design-system/accordian'
import Pressable from '@zet/design-system/pressable'
import ChatSupportFilled from '@zet/design-system/svg/ChatSupportFilled'
import Close from '@zet/design-system/svg/Close'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'

import { i18n as _i18n } from '../../localization'

const EarningsHeader = ({
  title,
  faqs: _faqs,
}: {
  title?: string
  faqs?: any
}) => {
  const [faqsBSheetVisible, setFaqsBSheetVisible] = useState(false)
  const { goBack } = useNavigation()
  function openBSheet() {
    setFaqsBSheetVisible(true)
    publishEvent('click_action', {
      item_name: 'earnings_subsection_faq',
      feature: 'earnings',
    })
  }
  function closeBSheet() {
    setFaqsBSheetVisible(false)
  }
  function handleBack() {
    goBack()
  }
  const faqsList = _i18n.t('teamEarningsFaqs')

  return (
    <XStack className="items-center justify-between px-3 py-2">
      <Pressable className="flex-row items-center" onPress={handleBack}>
        <Stack className="bg-grays-20 mr-2 rounded p-2">
          <Close />
        </Stack>
        <H5>{title || _i18n.t(`earningsList.headerTitle`)}</H5>
      </Pressable>
      <Pressable className="flex-row items-center" onPress={openBSheet}>
        <ChatSupportFilled color={colors.primary[100]} />
        <B4 className="text-primary-100">{i18n.t('faqsShort')}</B4>
      </Pressable>
      <BottomSheet
        visible={faqsBSheetVisible}
        onDismiss={closeBSheet}
        sheetName="earnings_subsection_faq"
      >
        <Stack className="mx-3">
          <H5 className="border-grays-30 border-b pb-3 text-center">
            {i18n.t('faqs')}
          </H5>
          <BottomSheetScrollView
            showsVerticalScrollIndicator={false}
            style={{
              maxHeight: DEVICE_HEIGHT * 0.5,
            }}
          >
            {(_faqs || faqsList)?.map((item, index) => {
              return (
                <Accordian
                  key={`earnings-faq-${index}`}
                  className="border-grays-40 mb-3 p-3"
                  title={item.question}
                  content={item.answer}
                />
              )
            })}
          </BottomSheetScrollView>
        </Stack>
      </BottomSheet>
    </XStack>
  )
}

export default EarningsHeader
